import {ColumnStore, WidgetColumn} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";

class SwivuUserOwnershipColumn extends WidgetColumn {
  static get $name() {
    return "SwivuUserOwnershipColumn";
  }

  static get type() {
    return WIDGET_KEYS.swivuUserOwnershipColumn;
  }

  static get defaults() {
    return {
      id: "ownershipButton",
      text: "Ownership",
      flex: 1,
      editor: false,
      type: "widget",
      groupable: false,
      widgets: [{
        type: "button",
        rendition: "text",
        cls: "b-transparent dark:text-[#c0c1c2] text-[#3a3733]",
        icon: "fa-solid fa-eye",
        text: "View",
        onClick: "up.onExpanderToggleHandler",
      }]
    }
  }

  swivuIsButtonDisabled(record) {
    return record.isDeactivated;
  }

  renderer({ widgets, record }) {
    const viewButton = widgets[0];
    viewButton.disabled = this.swivuIsButtonDisabled(record);
  }
}

ColumnStore.registerColumnType(SwivuUserOwnershipColumn);
